// extracted by mini-css-extract-plugin
export var BreadCrumbs = "BreadCrumbs-module--BreadCrumbs--0vqR4";
export var LangHY = "BreadCrumbs-module--LangHY--Dd19C";
export var Black = "BreadCrumbs-module--Black--v7zlK";
export var arrowLeft = "BreadCrumbs-module--arrowLeft--9mGVa";
export var arrowRight = "BreadCrumbs-module--arrowRight--4Vjbi";